export const versions = {
  version: "1.0.183",
  revision: "513085174",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5171-g513085174-dirty",
    hash: "g513085174",
    distance: 5171,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5171-g513085174-dirty",
    semverString: "1.0.183+5171.g513085174.dirty"
  }
};
